// Redirect automatico dalla pagina 404 alla home
if (document.body.classList.contains('page-404')) {
  window.location.replace('/');
}

// Reset zoom iOS Safari dopo chiusura popup (fallback)
function resetIOSZoom() {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    const original = viewport.getAttribute('content');
    viewport.setAttribute('content', original + ', maximum-scale=1.0');
    setTimeout(() => {
      viewport.setAttribute('content', original);
    }, 300);
  }
}

// Ascolta la chiusura del popup (adatta il selettore all'app che usi)
document.addEventListener('click', function(e) {
  if (e.target.closest('.popup-close, [aria-label="Close"], .newsletter-popup-close')) {
    resetIOSZoom();
  }
});

// Se non ci sono macbook non viene mostrato il blocco
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('ul.product-grid.slider').forEach(function (grid) {
    var slides = grid.querySelectorAll(':scope > li');
    var hasRealProduct = false;

    slides.forEach(function (slide) {
      var isPlaceholder = slide.querySelector('svg.placeholder-svg');
      if (!isPlaceholder) {
        hasRealProduct = true;
      }
    });

    // se nessuno slot ha un prodotto reale, nascondi l'intera sezione
    if (!hasRealProduct) {
      var section = grid.closest('.shopify-section');
      if (section) {
        section.style.display = 'none';
      }
    }
  });
});

// Check colori

(function () {
  function traduciLabelColore() {
    document.querySelectorAll('legend.form__label').forEach(function (leg) {
      leg.childNodes.forEach(function (node) {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() === 'Color:'
        ) {
          node.textContent = node.textContent.replace('Color:', 'Colore:');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', traduciLabelColore);

  // Osserva solo il container dei prodotti o variant-selects, non tutto il body
  document.addEventListener('DOMContentLoaded', function() {
    var target = document.getElementById('ProductGridContainer') || document.querySelector('variant-selects');
    if (!target) {
      setTimeout(function() {
        var t = document.querySelector('variant-selects');
        if (t) {
          var obs = new MutationObserver(traduciLabelColore);
          obs.observe(t, { childList: true, subtree: true });
        }
      }, 1000);
      return;
    }
    var obs = new MutationObserver(traduciLabelColore);
    obs.observe(target, { childList: true, subtree: true });
  });
})();


// filtri colore
(function() {
  const colorMap = {
    'gray': 'grigio', 'space gray': 'grigio', 'grigio siderale': 'grigio',
    'graphite': 'grigio', 'marble gray': 'grigio', 'gray titanium': 'grigio',
    'natural titanium': 'grigio', 'moonstone gray': 'grigio',
    'mystic gray': 'grigio', 'phantom gray': 'grigio',
    'titanium gray': 'grigio', 'onyx gray': 'grigio', 'titanium': 'grigio',
    'blue': 'blu', 'midnight': 'blu', 'sky blue': 'blu', 'icy blue': 'blu',
    'awesome iceblue': 'blu', 'sapphire blue': 'blu', 'pacific blue': 'blu',
    'sierra blue': 'blu', 'ultramarine': 'blu', 'blue titanium': 'blu',
    'titanium icyblue': 'blu', 'blue shadow': 'blu', 'cloud blue': 'blu',
    'midnight green': 'blu', 'blue titanic': 'blu', 'blue black': 'blu', 'silver blue': 'blu',
    'blue navy': 'blu navy', 'navy': 'blu navy', 'awesome navy': 'blu navy', 'stalight': 'blu navy',
    'white': 'bianco', 'galassia': 'bianco', 'white titanium': 'bianco',
    'cloud white': 'bianco', 'awesome white': 'bianco', 'prism white': 'bianco',
    'phantom white': 'bianco', 'starlight': 'bianco',
    'silver shadow': 'silver', 'silver blue titanium': 'silver',
    'white silver titanium': 'silver', 'phantom silver': 'silver', 'titanium whitesilver': 'silver',
    'pink gold': 'gold',
    'black': 'nero', 'phantom black': 'nero', 'onyx black': 'nero',
    'crafted black': 'nero', 'black titanium': 'nero', 'awesome black': 'nero',
    'ebony black': 'nero', 'prism black': 'nero', 'titanium jetblack': 'nero',
    'jetblack': 'nero', 'cosmic black': 'nero', 'space black': 'nero',
    'mezzanotte': 'nero', 'titanium black': 'nero',
    'red': 'rosso', 'coral': 'rosso', 'coral red': 'rosso', 'product(red)': 'rosso',
    'product (red)': 'rosso', 'producct (red)': 'rosso', 'procuct (red)': 'rosso',
    'producct(red)': 'rosso', 'product red': 'rosso',
    'green': 'verde', 'jade green': 'verde', 'alpine green': 'verde', 'mint': 'verde',
    'green water': 'verde', 'verde acqua': 'verde', 'lime': 'verde',
    'jade green titanium': 'verde', 'titanium green': 'verde', 'stage': 'verde',
    'light green': 'verde', 'awesome lime': 'verde', 'phantom green': 'verde',
    'pink': 'rosa', 'pink gold titanium': 'rosa', 'phantom pink': 'rosa',
    'yellow': 'giallo', 'amber yellow': 'giallo', 'titanium yellow': 'giallo', 'onyx yellow': 'giallo',
    'purple': 'viola', 'lavender': 'viola', 'cobalt violet': 'viola', 'bora purple': 'viola',
    'titanium violet': 'viola', 'violet': 'viola', 'phantom violet': 'viola', 'deep purple': 'viola',
    'orange': 'arancione', 'sandstone orange': 'arancione',
    'titanium orange': 'arancione', 'cosmic orange': 'arancione',
    'desert titanium': 'marrone', 'khaki': 'marrone',
    'cream': 'beige',
    'teal': 'multicolore', 'azzurro': 'multicolore', 'peach': 'multicolore'
  };

  const invalidValues = new Set(['n/d', 'nd', '']);
  const isInvalidValue = (val) => {
    if (!val) return true;
    return invalidValues.has(val.toString().toLowerCase().trim());
  };

  function getBaseColor(color) {
    if (!color) return color;
    return colorMap[color.toLowerCase()] || color.toLowerCase();
  }

  // Cache dati prodotti per collection
  const productDataCache = {};

  async function fetchProductData(collectionHandle) {
    if (productDataCache[collectionHandle]) {
      return productDataCache[collectionHandle];
    }
    try {
      const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250`);
      const data = await res.json();
      const products = data.products || [];
      const map = {};
      products.forEach(p => {
        const colors = new Set();
        const memory = new Set();
        const ram = new Set();
        p.variants.forEach(v => {
          if (!v.available) return;
          p.options.forEach((opt, idx) => {
            const optName = opt.name.toLowerCase();
            const value = v[`option${idx + 1}`];
            if (!value || isInvalidValue(value)) return;
            if (optName === 'memoria' || optName === 'storage') {
              memory.add(value.toLowerCase());
            } else if (optName === 'color' || optName === 'colore') {
              colors.add(value.toLowerCase());
            } else if (optName === 'ram') {
              ram.add(value.toLowerCase());
            }
          });
        });
        map[p.handle] = {
          available_colors: Array.from(colors),
          available_memory: Array.from(memory),
          available_ram: Array.from(ram)
        };
      });
      productDataCache[collectionHandle] = map;
      return map;
    } catch(e) {
      console.error('Fetch product data error:', e);
      return {};
    }
  }

  // Legge il colore attivo dalla label della checkbox selezionata
  function getActiveColorFromDOM() {
    const checked = document.querySelector('input[type="checkbox"][name*="color-pattern"]:checked');
    if (!checked) return null;
    const li = checked.closest('li');
    if (!li) return null;
    const labelText = li.querySelector('.facet-checkbox__text, .visually-hidden')?.textContent?.trim();
    if (!labelText) return null;
    const clean = labelText.replace(/\s*\(\d+.*?\)\s*$/, '').trim().toLowerCase();
    return clean;
  }

  // Legge la memoria attiva dalla checkbox selezionata
  function getActiveMemoryFromDOM() {
    const checked = document.querySelector('input[type="checkbox"][name*="option.memoria"]:checked');
    if (!checked) return null;
    const li = checked.closest('li');
    if (!li) return null;
    const labelText = li.querySelector('.facet-checkbox__text, .visually-hidden')?.textContent?.trim();
    if (!labelText) {
      return checked.value?.toLowerCase() || null;
    }
    return labelText.replace(/\s*\(\d+.*?\)\s*$/, '').trim().toLowerCase();
  }

  // Legge la RAM attiva dalla checkbox selezionata (filtro visibile solo su collezioni con opzione RAM, es. MacBook)
  function getActiveRamFromDOM() {
    const checked = document.querySelector('input[type="checkbox"][name*="option.ram"]:checked');
    if (!checked) return null;
    const li = checked.closest('li');
    if (!li) return null;
    const labelText = li.querySelector('.facet-checkbox__text, .visually-hidden')?.textContent?.trim();
    if (!labelText) {
      return checked.value?.toLowerCase() || null;
    }
    return labelText.replace(/\s*\(\d+.*?\)\s*$/, '').trim().toLowerCase();
  }

  function processGrid(productData) {
    const activeColor = getActiveColorFromDOM();
    const activeMemory = getActiveMemoryFromDOM();
    const activeRam = getActiveRamFromDOM();

    if ((!activeColor && !activeMemory && !activeRam) || !productData) {
      // Nessun filtro custom attivo: ripristina pulsante "Carica di più"
      const loadMore = document.querySelector('load-more, .load-more');
      if (loadMore) loadMore.style.display = '';
      return;
    }

    const cards = document.querySelectorAll('#product-grid li.grid__item');
    if (!cards.length) return;

    let visibleCount = 0;

    cards.forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      const match = link?.href.match(/\/products\/([^?#/]+)/);
      if (!match) { visibleCount++; return; }
      const handle = match[1];
      const data = productData[handle];
      if (!data) { visibleCount++; return; }

      let colorOk = true;
      let memoryOk = true;
      let ramOk = true;

      if (activeColor) {
        colorOk = data.available_colors.some(color => {
          return getBaseColor(color) === activeColor;
        });
      }

      if (activeMemory) {
        memoryOk = data.available_memory.some(mem => mem === activeMemory);
      }

      if (activeRam) {
        ramOk = (data.available_ram || []).some(r => r === activeRam);
      }

      if (!colorOk || !memoryOk || !ramOk) {
        card.style.display = 'none';
      } else {
        card.style.display = '';
        visibleCount++;
      }
    });

    const counters = document.querySelectorAll('#ProductCountDesktop, #ProductCount');
    counters.forEach(el => {
      el.textContent = el.textContent.replace(/\d+/, visibleCount);
    });

    // Nasconde "Carica di più" quando un filtro custom è attivo
    const loadMore = document.querySelector('load-more, .load-more');
    if (loadMore) loadMore.style.display = 'none';
  }

  async function init() {
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
    if (!collectionHandle) return;

    const productData = await fetchProductData(collectionHandle);
    processGrid(productData);
  }

  // Esegui al load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Osserva aggiornamenti AJAX del container
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 200);
    });
    observer.observe(container, { childList: true, subtree: true });
  });
})();


// Auto-seleziona la variante disponibile più economica sulla pagina prodotto
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  if (!window.__productVariants) return;

  const invalidOptionValues = new Set(['n/d', 'nd', '']);
  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function selectCheapestAvailable() {
    const variants = window.__productVariants;

    // Solo varianti realmente disponibili e senza opzioni "fantasma" (N/D)
    const candidates = variants.filter(function(v) {
      return v.available && !(v.options || []).some(isInvalidOption);
    });
    if (!candidates.length) return;

    const cheapest = candidates.reduce(function(min, v) {
      return v.price < min.price ? v : min;
    }, candidates[0]);

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    cheapest.options.forEach(function(optionValue, index) {
      const fieldset = variantSelects.querySelectorAll('fieldset')[index];
      if (!fieldset) return;

      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
        .find(i => i.value === optionValue);

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  setTimeout(selectCheapestAvailable, 800);
})();


// Auto-seleziona la memoria più economica disponibile quando cambia il colore
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  if (!window.__productVariants) return;

  const invalidOptionValues = new Set(['n/d', 'nd', '']);
  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function selectCheapestAvailableMemory(selectedColor) {
    const variants = window.__productVariants;

    const candidates = variants.filter(function(v) {
      if (!v.available) return false;
      if ((v.options || []).some(isInvalidOption)) return false;
      return v.options.some(function(o) {
        return o.toLowerCase() === selectedColor.toLowerCase();
      });
    });

    if (!candidates.length) return;

    const cheapest = candidates.reduce(function(min, v) {
      return v.price < min.price ? v : min;
    }, candidates[0]);

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const fieldsets = variantSelects.querySelectorAll('fieldset');

    cheapest.options.forEach(function(optionValue, index) {
      const fieldset = fieldsets[index];
      if (!fieldset) return;

      const legend = fieldset.querySelector('legend');
      const legendText = legend?.textContent?.toLowerCase() || '';

      if (legendText.includes('memor') || legendText.includes('storage')) {
        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
          .find(i => i.value === optionValue);

        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('change', function(e) {
    const input = e.target;
    if (input.type !== 'radio') return;

    const fieldset = input.closest('fieldset');
    const legend = fieldset?.querySelector('legend');
    const legendText = legend?.textContent?.toLowerCase() || '';

    if (legendText.includes('color') || legendText.includes('colore')) {
      setTimeout(function() {
        selectCheapestAvailableMemory(input.value);
      }, 50);
    }
  });
})();

// Rimuove "(N)" dai filtri facet
(function() {
  function pulisciContatori() {
    // Etichette delle checkbox (es. "Bianco (14)")
    document.querySelectorAll('.facet-checkbox__text, .facets__item .visually-hidden').forEach(function(el) {
      if (!el.dataset.cleaned) {
        const originale = el.textContent;
        const pulito = originale.replace(/\s*\(\d+.*?\)\s*$/, '').trim();
        if (originale !== pulito) {
          el.textContent = pulito;
          el.dataset.cleaned = 'true';
        }
      }
    });

    // Titoli delle sezioni filtri (es. "Colore (1)")
    document.querySelectorAll('.facets__summary, .facets__heading, .facets__display-header').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const originale = node.textContent;
          const pulito = originale.replace(/\s*\(\d+\)\s*/g, '').trimEnd();
          if (originale !== pulito) {
            node.textContent = pulito + ' ';
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', pulisciContatori);

  document.addEventListener('DOMContentLoaded', function() {
    const target = document.getElementById('ProductGridContainer')
      || document.querySelector('.facets')
      || document.body;
    const obs = new MutationObserver(function() {
      pulisciContatori();
    });
    obs.observe(target, { childList: true, subtree: true });
  });
})();


// Mostra prezzo dei prodotti realmente disponibili

// Mostra "Da X" usando solo varianti disponibili - funziona ovunque
(function() {
  const productPriceCache = {};
  const invalidOptionValues = new Set(['n/d', 'nd', '']);

  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function formatPrice(amount) {
    return '€' + amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  async function fixPriceForProduct(handle, priceEl) {
    if (priceEl.dataset.fixed === handle) return;

    try {
      let minPrice = productPriceCache[handle];
      if (minPrice === undefined) {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) {
          productPriceCache[handle] = null;
          return;
        }
        const product = await res.json();
        const availablePrices = product.variants
          .filter(v => v.available)
          // Esclude le varianti "fantasma" con opzioni N/D (non selezionabili in scheda prodotto)
          .filter(v => !(v.options || []).some(isInvalidOption))
          .map(v => v.price / 100) // /products/X.js ritorna i prezzi in centesimi
          .filter(p => !isNaN(p));
        if (availablePrices.length === 0) {
          productPriceCache[handle] = null;
          return;
        }
        minPrice = Math.min(...availablePrices);
        productPriceCache[handle] = minPrice;
      }
      if (minPrice === null) return;

      priceEl.textContent = 'Da ' + formatPrice(minPrice);
      priceEl.dataset.fixed = handle;
    } catch(e) {
      console.error('Fix price error:', e);
    }
  }

  function processAllProductCards() {
    // Cerca tutti i link prodotto in tutta la pagina
    const links = document.querySelectorAll('a[href*="/products/"]');
    const processed = new Set();

    links.forEach(link => {
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const handle = match[1];

      // Trova il wrapper della card in modo mirato: non risale "alla cieca"
      // (in caroselli/slider con card poco isolate, risalire troppi livelli
      // può far prendere il prezzo di UN'ALTRA card vicina)
      const card = link.closest('.card, .card-wrapper, li.grid__item, .grid__item') || link.parentElement;
      if (!card) return;

      const priceEl = card.querySelector('.price-item--regular, .price-item--sale, .price-item');
      if (priceEl && !processed.has(priceEl)) {
        processed.add(priceEl);

        // NON toccare il blocco prezzo principale della pagina prodotto:
        // lì deve comandare solo il tema, in base alla variante selezionata
        if (priceEl.closest('[id*="__main"]')) return;

        fixPriceForProduct(handle, priceEl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAllProductCards);
  } else {
    processAllProductCards();
  }

  // Osserva aggiornamenti AJAX su tutta la pagina
  document.addEventListener('DOMContentLoaded', function() {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processAllProductCards, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

  // toglie icona basso dx home
document.addEventListener('DOMContentLoaded', function() {

  const hideHcaptcha = () => {
    const el = document.querySelector('#shop-hcaptcha-badge-container');
    if (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
    }
  };

  hideHcaptcha();

  const observer = new MutationObserver(hideHcaptcha);
  observer.observe(document.body, { childList: true, subtree: true });

  [500, 1000, 2000, 4000].forEach(t => setTimeout(hideHcaptcha, t));

});

(function () {
  const OLD_PATH = '/collections/all';
  const NEW_PATH = '/collections/ricondizionati';

  function fixSeeAllLink(root) {
    const links = root.querySelectorAll(`a.default-heading-link[href="${OLD_PATH}"]`);
    links.forEach(link => {
      link.setAttribute('href', NEW_PATH);
    });
  }

  // Fix eventuali istanze già presenti nel DOM al caricamento
  document.addEventListener('DOMContentLoaded', () => fixSeeAllLink(document));

  // Osserva il predictive search per correggere il link ogni volta che viene rigenerato
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        fixSeeAllLink(document);
      }
    }
  });

  // Aspetta che il body sia pronto, poi osserva tutto l'albero
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

//escluedi prodotti dalla ricerca

(function () {
  const HIDDEN_HANDLES = [
    'protezione-display'
  ];

  function hideFromPredictiveSearch() {
    const items = document.querySelectorAll('li[id^="predictive-search-option-product"]');
    items.forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link) return;

      const isHidden = HIDDEN_HANDLES.some(handle =>
        link.getAttribute('href').includes(`/products/${handle}`)
      );

      if (isHidden) item.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideFromPredictiveSearch();

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          hideFromPredictiveSearch();
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

//cambia click su protezione display

(function () {
  const NON_CLICKABLE_HANDLES = [
    'protezione-display',
  ];
  const REDIRECT_URL = '/pages/protezione-display';

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    const isBlocked = NON_CLICKABLE_HANDLES.some(handle =>
      link.getAttribute('href').includes(`/products/${handle}`)
    );

    if (isBlocked) {
      e.preventDefault();
      e.stopPropagation();
      window.open(REDIRECT_URL, '_blank');
    }
  }, true);
}());

// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati — no modifiche a theme.liquid
// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati
// - Pagina prodotto: verifica appartenenza via fetch
// - Pagina collezione: check diretto sull'URL
// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati
// - Pagina prodotto: verifica appartenenza via fetch
// - Pagina collezione: check diretto sull'URL
(function () {
  var excludedCollections = ['macbook-ricondizionati', 'rescue'];
  var path = window.location.pathname;

  // Caso A: pagina di listing di una collezione esclusa -> nascondi tutti i badge
  var collectionMatch = path.match(/\/collections\/([^/?#]+)/);
  if (collectionMatch && excludedCollections.indexOf(collectionMatch[1]) !== -1) {
    document.body.classList.add('no-badge-batteria');
    return;
  }

  // Caso B: pagina prodotto -> nascondi solo se il prodotto è in una collezione esclusa
  var productMatch = path.match(/\/products\/([^/?#]+)/);
  if (productMatch) {
    var currentHandle = productMatch[1];
    Promise.all(excludedCollections.map(function (handle) {
      return fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) { return data.products.some(function (p) { return p.handle === currentHandle; }); })
        .catch(function () { return false; });
    })).then(function (results) {
      if (results.some(Boolean)) document.body.classList.add('no-badge-batteria');
    });
    return;
  }

  // Caso C: qualunque altra pagina (home, altre collezioni, ecc.)
  // -> scandisci le card visibili e nascondi solo il badge dei prodotti Rescue/MacBook
  var excludedHandlesPromise = Promise.all(excludedCollections.map(function (handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) { return data.products.map(function (p) { return p.handle; }); })
      .catch(function () { return []; });
  })).then(function (arrays) {
    return new Set([].concat.apply([], arrays));
  });

  function hideBadgesInCards(excludedHandles) {
    document.querySelectorAll('.samita_productLabel').forEach(function (label) {
      if (label.dataset.batteryChecked) return;
      var link = label.closest('a[href*="/products/"]');
      if (!link) {
        var card = label.closest('[class*="card"]');
        link = card ? card.querySelector('a[href*="/products/"]') : null;
      }
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      label.dataset.batteryChecked = '1';
      if (excludedHandles.has(m[1])) {
        var container = label.closest('.samita-container') || label;
        container.style.setProperty('display', 'none', 'important');
      }
    });
  }

  excludedHandlesPromise.then(function (excludedHandles) {
    hideBadgesInCards(excludedHandles);
    new MutationObserver(function () { hideBadgesInCards(excludedHandles); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();

  // Togli il DA prima del prezzo

(function () {
  function stripDaPrefix() {
    document.querySelectorAll('.price-item.price-item--regular[data-fixed]').forEach(function (el) {
      // Solo il blocco prezzo della pagina prodotto (id "price-template--...__main")
      if (!el.closest('[id*="__main"]')) return;

      var newText = el.textContent.replace(/^\s*Da\s+/i, '');
      if (newText !== el.textContent) {
        el.textContent = newText;
      }
    });
  }

  stripDaPrefix();
  document.addEventListener('DOMContentLoaded', stripDaPrefix);

  var debounceTimer;
  var bodyObserver = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(stripDaPrefix, 50);
  });

  bodyObserver.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();

// Mostra subito il video nella scheda prodotto, se presente, indipendentemente dalla posizione tra gli swatch
(function () {
  function attivaVideo(gallery) {
    var thumbList = gallery.querySelector('.thumbnail-list');
    if (!thumbList) return;

    var videoBtn = thumbList.querySelector('button[aria-label*="video" i]');
    if (!videoBtn) return;

    var li = videoBtn.closest('[data-target]');
    var mediaId = li ? li.getAttribute('data-target') : null;
    if (!mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    } else {
      videoBtn.click();
    }
  }

  function run() {
    document.querySelectorAll('media-gallery').forEach(attivaVideo);
  }

  if (window.customElements && customElements.get('media-gallery')) {
    run();
  } else if (window.customElements) {
    customElements.whenDefined('media-gallery').then(function () {
      setTimeout(run, 50);
    });
  }

  // fallback di sicurezza, nel caso il component tardi ad agganciarsi
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(run, 400);
  });
})();

// Menu Extra Riparalo
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('details, .mega-menu').forEach(function (menu) {
    var summary = menu.querySelector('summary');
    if (summary && summary.textContent.trim() === 'Riparalo') {
      var items = menu.querySelectorAll('.grid__item');
      if (items.length >= 4 && !menu.querySelector('.riparalo-extra-links')) {
        var grid = items[0].closest('.grid');
        if (grid) {
          var extra = document.createElement('div');
          extra.className = 'riparalo-extra-links';
          extra.innerHTML = `
            <a href="https://www.riparalo.store/pages/chi-siamo">Chi Siamo</a>
            <a href="https://www.riparalo.store/pages/telefoni-ricondizionati">Ricondizionati</a>
            <a href="https://www.riparalo.store/pages/servizi">Servizi</a>
            <a href="https://www.riparalo.store/pages/consulenza">Consulenza</a>
            <a href="https://www.riparalo.store/pages/franchising">Franchising</a>
          `;
          grid.appendChild(extra);
        }
      }
    }
  });
});

// Varianti non disponibili
(function () {
  if (window.__ndVariantiInit) return;
  window.__ndVariantiInit = true;

  function nascondiVariantiNonDisponibili(container) {
    var root = container || document;

    root.querySelectorAll('input.disabled').forEach(function (input) {
      input.style.display = 'none';
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = 'none';
    });

    root.querySelectorAll('input[type="radio"]:not(.disabled)').forEach(function (input) {
      input.style.display = '';
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = '';
    });

    // Se l'opzione attualmente selezionata è stata nascosta (disabled),
    // sposta la selezione sulla prima variante disponibile dello stesso fieldset
    root.querySelectorAll('fieldset').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.classList.contains('disabled')) {
        var firstAvailable = fieldset.querySelector('input[type="radio"]:not(.disabled)');
        if (firstAvailable) {
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    nascondiVariantiNonDisponibili();
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('input[type="radio"]')) {
            nascondiVariantiNonDisponibili(node);
          }
        });
      });
      nascondiVariantiNonDisponibili();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();

// Unifica varianti duplicate del filtro Memoria (es. 128GB / 128gb)
(function () {
  function normalizzaMemoria(str) {
    if (!str) return '';
    return str.trim().toLowerCase();
  }

  function formattaMemoria(str) {
    // Forza il formato "128GB" a partire da qualsiasi casistica (128gb, 128Gb, ecc.)
    var match = str.trim().match(/^(\d+)\s*gb$/i);
    if (match) return match[1] + 'GB';
    return str.trim();
  }

  function unificaFiltroMemoria(root) {
    root = root || document;
    var inputs = root.querySelectorAll(
      'input[type="checkbox"][name*="option.memoria" i], input[type="checkbox"][name*="option.storage" i]'
    );
    if (!inputs.length) return;

    var gruppi = {};
    inputs.forEach(function (input) {
      var key = normalizzaMemoria(input.value);
      if (!key) return;
      if (!gruppi[key]) gruppi[key] = [];
      gruppi[key].push(input);
    });

    Object.keys(gruppi).forEach(function (key) {
      var group = gruppi[key];
      if (group.length < 2) return;

      var primario = group[0];
      var duplicati = group.slice(1);

      if (!primario.dataset.memUnified) {
        primario.dataset.memUnified = '1';

        // Uniforma il testo visibile al formato standard (es. 128GB)
        var liPrimario = primario.closest('li');
        if (liPrimario) {
          var testoEl = liPrimario.querySelector('.facet-checkbox__text, .visually-hidden');
          if (testoEl) {
            var testoOriginale = testoEl.textContent;
            var pulito = testoOriginale.replace(/\s*\(\d+.*?\)\s*$/, '');
            var extra = testoOriginale.slice(pulito.length);
            testoEl.textContent = formattaMemoria(pulito) + extra;
          }
        }

        // Se un duplicato era già selezionato (es. da URL), seleziona anche il primario
        if (group.some(function (i) { return i.checked; }) && !primario.checked) {
          primario.checked = true;
        }

        // Alla selezione/deselezione del primario, replica lo stato sui duplicati nascosti
        primario.addEventListener('change', function () {
          duplicati.forEach(function (dup) {
            if (dup.checked !== primario.checked) {
              dup.checked = primario.checked;
              dup.dispatchEvent(new Event('input', { bubbles: true }));
              dup.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      // Nasconde le voci duplicate (restano nel DOM per essere spuntate via JS)
      duplicati.forEach(function (dup) {
        if (dup.checked && !primario.checked) {
          primario.checked = true;
        }
        var liDup = dup.closest('li');
        if (liDup) {
          liDup.style.display = 'none';
        } else {
          dup.style.display = 'none';
          var label = root.querySelector('label[for="' + dup.id + '"]');
          if (label) label.style.display = 'none';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    unificaFiltroMemoria();
    var target = document.querySelector('.facets') || document.body;
    var obs = new MutationObserver(function () {
      unificaFiltroMemoria();
    });
    obs.observe(target, { childList: true, subtree: true });
  });
})();

// PAYPAL CUSTOM — testo "Paga a rate con PayPal" sotto il prezzo
(function() {
  function insertPayPalText() {
    var priceContainer = document.querySelector('[id*="__main"] .price');
    if (!priceContainer || document.getElementById('paypal-rate-text')) return;

    var badge = document.createElement('div');
    badge.id = 'paypal-rate-text';
    badge.innerHTML = '💳 Paga a rate con PayPal';
    badge.style.cssText = 'font-size:13px; color:#555; margin-top:6px;';
    priceContainer.insertAdjacentElement('afterend', badge);
  }

  document.addEventListener('DOMContentLoaded', insertPayPalText);

  // Il tema rigenera il blocco prezzo al cambio variante, rimuovendo il badge:
  // lo osserviamo e lo reinseriamo ogni volta che sparisce
  var observer = new MutationObserver(function() {
    insertPayPalText();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// PAYPAL PULSANTE
(function() {
  function insertPayPalRateBadge() {
    var ppButton = document.querySelector('[id*="__main"] .shopify-payment-button');
    if (!ppButton || document.getElementById('paypal-rate-badge')) return;

    ppButton.style.position = 'relative';

    var badge = document.createElement('div');
    badge.id = 'paypal-rate-badge';
    badge.innerHTML = 'anche a rate';
    badge.style.cssText = 'position:absolute; top:-10px; right:8px; background:#1a1a1a; color:#fff; font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; z-index:5;';
    ppButton.appendChild(badge);
  }

  document.addEventListener('DOMContentLoaded', insertPayPalRateBadge);

  var observer = new MutationObserver(function() {
    insertPayPalRateBadge();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// KLARNA — "Paga in 3 rate da X € senza interessi" sotto il testo PayPal (Shopify Payments)
// Funziona sia sulla pagina prodotto sia nell'anteprima rapida (quick view) dalle collezioni
(function () {
  // Soglie in euro: verifica i limiti reali di Klarna Pay in 3 sul tuo checkout
  var KLARNA_MIN = 35;
  var KLARNA_MAX = 1500;

  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  // Legge il prezzo della variante selezionata dal blocco prezzo del tema
  function leggiPrezzo(priceContainer) {
    var el = priceContainer.classList.contains('price--on-sale')
      ? priceContainer.querySelector('.price__sale .price-item--sale')
      : priceContainer.querySelector('.price__regular .price-item--regular');
    if (!el) el = priceContainer.querySelector('.price-item');
    if (!el) return null;

    // "€1.234,56" / "Da €519,00" -> 1234.56 / 519
    var txt = el.textContent.replace(/[^\d,.]/g, '');
    if (!txt) return null;
    var n = parseFloat(txt.replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function aggiornaKlarna() {
    var priceContainer = document.querySelector('[id*="__main"] .price');
    if (!priceContainer) return;

    var box = document.getElementById('klarna-rate-text');
    var prezzo = leggiPrezzo(priceContainer);

    // Fuori soglia: niente rate Klarna al checkout, quindi niente messaggio
    if (prezzo === null || prezzo < KLARNA_MIN || prezzo > KLARNA_MAX) {
      if (box) box.remove();
      return;
    }

    // Rata arrotondata per eccesso al centesimo
    var rata = fmt.format(Math.ceil(prezzo * 100 / 3) / 100);

    if (!box) {
      box = document.createElement('div');
      box.id = 'klarna-rate-text';
      box.innerHTML =
        '<span class="klarna-rate__badge">Klarna.</span>' +
        '<span>Paga in 3 rate da <span class="klarna-rate__importo"></span> senza interessi</span>';
      var anchor = document.getElementById('paypal-rate-text') || priceContainer;
      anchor.insertAdjacentElement('afterend', box);
    }

    var importo = box.querySelector('.klarna-rate__importo');
    if (importo.textContent !== rata) importo.textContent = rata;
  }

  document.addEventListener('DOMContentLoaded', function () {
    aggiornaKlarna();

    // L'anteprima rapida viene iniettata dinamicamente fuori dalla sezione prodotto,
    // quindi serve osservare il body (con debounce, e il box viene toccato solo se cambia
    // davvero qualcosa: nessun loop). Copre anche il cambio variante in pagina prodotto.
    var debounceTimer;
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(aggiornaKlarna, 80);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  });
})();

// PAGINA /collections — nasconde le collezioni con "_" davanti e quelle senza prodotti disponibili,
// e aggiorna "N articoli" contando solo i prodotti disponibili
(function () {
  // Solo la pagina elenco collezioni (/collections, anche con prefisso lingua tipo /en/collections)
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/^(\/[a-z]{2}(-[a-z]{2})?)?\/collections$/i.test(path)) return;

  function handleDaLink(link) {
    var m = (link.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Risale dal link fino alla "cella" della griglia: l'antenato più alto che contiene
  // ancora SOLO link a questa collezione. Nascondendo la cella intera, la griglia
  // si ricompatta senza lasciare buchi.
  function cellaGriglia(link, handle, root) {
    var el = link;
    while (el.parentElement && el.parentElement !== root) {
      var parent = el.parentElement;
      var altre = Array.prototype.some.call(
        parent.querySelectorAll('a[href*="/collections/"]'),
        function (a) { var h = handleDaLink(a); return h && h !== handle; }
      );
      if (altre) break;
      el = parent;
    }
    return el;
  }

  function trovaCard(root) {
    var cards = [];
    root.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      var handle = handleDaLink(link);
      if (!handle) return;
      var card = cellaGriglia(link, handle, root);
      if (cards.some(function (c) { return c.card === card; })) return;
      cards.push({ card: card, handle: handle });
    });
    return cards;
  }

  // Titolo che inizia con "_" (es. "_iPhone", "_macbook", "_Samsung")
  function haUnderscore(card, handle) {
    return /(^|\s)_\S/.test(card.textContent) || handle.charAt(0) === '_';
  }

  // Numero di prodotti con almeno una variante disponibile (null = errore, card lasciata visibile)
  function contaDisponibili(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) {
        return (data.products || []).filter(function (p) {
          return (p.variants || []).some(function (v) { return v.available; });
        }).length;
      })
      .catch(function () { return null; });
  }

  // Sostituisce "26 articoli" con il numero di prodotti disponibili
  function aggiornaConteggio(card, n) {
    var walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (/\d+\s+articol[oi]/i.test(node.textContent)) {
        node.textContent = node.textContent.replace(
          /\d+\s+articol[oi]/i,
          n + (n === 1 ? ' articolo' : ' articoli')
        );
        return;
      }
    }
  }

  function run() {
    // Solo il contenuto della pagina, mai header/menu
    var root = document.getElementById('MainContent') || document.querySelector('main');
    if (!root) return;

    trovaCard(root).forEach(function (item) {
      var card = item.card;

      if (haUnderscore(card, item.handle)) {
        card.style.setProperty('display', 'none', 'important');
        return;
      }

      // Nascosta finché non sappiamo se ha prodotti disponibili (evita il "flash")
      card.style.opacity = '0';

      contaDisponibili(item.handle).then(function (n) {
        if (n === 0) {
          card.style.setProperty('display', 'none', 'important');
        } else if (n !== null) {
          aggiornaConteggio(card, n);
        }
        card.style.opacity = '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

// CARD PRODOTTO — rata Klarna + garanzia sotto il prezzo (collezioni, home, prodotti consigliati)
// Usa il prezzo già corretto dallo script "Mostra Da X" (elementi con data-fixed)
(function () {
  var KLARNA_MIN = 35;
  var KLARNA_MAX = 1500;
  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  function aggiungiInfoCard() {
    document.querySelectorAll('.price-item[data-fixed]').forEach(function (priceEl) {
      // Mai nella pagina prodotto: lì ci sono già i blocchi Klarna/PayPal
      if (priceEl.closest('[id*="__main"]')) return;

      var priceBox = priceEl.closest('.price');
      if (!priceBox) return;

      // "Da €1.459,00" -> 1459
      var prezzo = parseFloat(priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.'));
      if (isNaN(prezzo)) return;

      var testo = 'Garanzia 24 mesi';
      if (prezzo >= KLARNA_MIN && prezzo <= KLARNA_MAX) {
        var rata = '€' + (Math.ceil(prezzo * 100 / 3) / 100).toFixed(2).replace('.', ',');
        testo = 'o 3 rate da ' + rata + ' senza interessi · ' + testo;
      }

      var box = priceBox.nextElementSibling;
      if (!box || !box.classList.contains('card-extra')) {
        box = document.createElement('div');
        box.className = 'card-extra';
        priceBox.insertAdjacentElement('afterend', box);
      }
      if (box.textContent !== testo) box.textContent = testo;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    aggiungiInfoCard();
    var debounceTimer;
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(aggiungiInfoCard, 400);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();